import * as React from 'react';

import * as styles from './InlineFilterGroup.css';

export const InlineFilterGroup: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
